// @flow

import { createStore, applyMiddleware } from 'redux'
// $FlowFixMe
// import { persistStore, persistReducer } from 'redux-persist'
// $FlowFixMe
// import storage from 'redux-persist/lib/storage'
// $FlowFixMe
// import autoMergeLevel1 from 'redux-persist/lib/stateReconciler/autoMergeLevel1'
import createSagaMiddleware from 'redux-saga'
// $FlowFixMe
import { createTracker } from 'redux-segment'
// $FlowFixMe
import { connectRouter, routerMiddleware } from 'connected-react-router'

import { default as rootReducer, rootSaga } from 'src/ducks'
import { customMapper } from './customMapper'
import history from './history'

const tracker = createTracker(customMapper)
const sagaMiddleware = createSagaMiddleware()
const middleware = [sagaMiddleware, routerMiddleware(history), tracker]
const enchancers = []
// const persistConfig = {
//   key: 'root',
//   blacklist: ['encryption', 'stripe', 'form', 'locations'],
//   stateReconciler: autoMergeLevel1,
//   storage
// }

if (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__) {
  enchancers.push(window.__REDUX_DEVTOOLS_EXTENSION__())
}

// const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = createStore(
  connectRouter(history)(rootReducer),
  ...enchancers,
  applyMiddleware(...middleware)
)
// export const persistor = persistStore(store)

sagaMiddleware.run(rootSaga)



// WEBPACK FOOTER //
// ./src/config/store.js